import React, { useEffect, useState } from "react";
import PrimaryButton from "../PrimaryButton";
import GreyButton from "../GreyButton";
import { useFormik } from "formik";
import RadioSelection from "../RadioSelection";
import DayBox from "./DayBox";
import { DatePicker, TimePicker, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { CalendarOutlined } from "@ant-design/icons";
import { createOffer } from "../../../services/offerService";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { ReactComponent as InfoIcon1 } from "../../../Assets/Icons/info.svg";
import Checkbox from "../Checkbox";
import { ReactComponent as UncheckedIcon } from "../../../Assets/Icons/uncheckedBlackBox.svg";
import Selector from "../Selector";
import { ReactComponent as DownArrow } from "../../../Assets/Icons/greyDownArrow.svg";
import Input from "../FormInputs";
import { isValidUrl } from "../../../utils/utilFunctions";
// import RedemptionMethodPopup from "../RedemptionMethodPopup";
import SelectOption from "./SelectOption";
import alphanumericIcon from "../../../Assets/Icons/AlphanumericIcon.svg";
import qrIcon from "../../../Assets/Icons/QRicon.svg";
import barcodeIcon from "../../../Assets/Icons/Barcodeicon.svg";
import "./offerform.scss";

dayjs.extend(utc);
dayjs.extend(timezone);
const CustomizeOffer = ({
  stepIndex,
  setStepIndex,
  handlePrevious,
  setPayloadData,
  editOfferData,
  isEdit,
  selectedMerchant,
}) => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state?.offerReducer?.loading);
  const offerData = useSelector((state) => state?.offerReducer?.createdOffer);
  console.log(offerData, "offerDataofferDataofferData");
  const [useDefaultTime, setUseDefaultTime] = useState(false);
  // const [redemptionMethodUrl, setRedemptionMethodUrl] = useState(null);
  const [showRedemptionModal, setShowRedemptionModal] = useState(false);
  const [showVerificationModal, setShowVerificationModal] = useState(false); // Control modal visibility
  const [modalContent, setModalContent] = useState("Alphanumeric Code"); // Store content type (QR or Barcode)
  const [showUploadDocument, setShowUploadDocument] = useState(false); // State to control UploadDocument visibility
  const [selectedVerification, setSelectedVerification] = useState(""); // Track "upload" or "auto-generate"
  const [isSubmitted, setIsSubmitted] = useState(false);
  const weekDays = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  const format = "hh:mm A";

  // const getDefaultTradingHours = () => {
  //   return {
  //     startTime: "12:01 AM",
  //     endTime: "11:59 PM",
  //   };
  // };

  const fillUpForm = (data) => {
    // Set redemption method and handle checkbox state
    if (data?.redemptionMethod) {
      // Handle if redemptionMethod comes as an array
      const method = data.redemptionMethod;

      // Convert the method to proper format
      const formattedMethod =
        method === "QR_CODE"
          ? "QR Code"
          : method === "BAR_CODE"
            ? "BarCode"
            : method === "SWOODLE_CODE_OFFER"
              ? "Alphanumeric Code"
              : method;

      setFieldValue("redemedOffer", formattedMethod);

    }

    // Set website URL if it exists
    if (data?.callback_url) {
      setFieldValue("url", data.callback_url);
    }

    // First set the ruleSelection based on necessaryRule
    const necessaryRule = data?.necessaryRule
      ? data?.necessaryRule
      : "REDEEM_ONCE";
    console.log(necessaryRule, "necessaryRule necessaryRule necessaryRule");
    setFieldValue("ruleSelection", necessaryRule);

    // Then map redemptionFrequency to rules based on the ruleSelection
    if (data?.redemptionFrequency) {
      let ruleValue = "";
      if (necessaryRule === "OFFER_AVAILABLE_THROUGHOUT_YEAR") {
        switch (data.redemptionFrequency) {
          case "DAILY":
            ruleValue = "Redeem Once Daily";
            break;
          case "ONCE":
            ruleValue = "Redeem Once Daily";
            break;
          case "IN_A_WEEK":
            ruleValue = "Redeem Once Every Week";
            break;
          case "EVERY_30_DAYS":
            ruleValue = "Redeem Once Every Month";
            break;
          case "ONCE_IN_12_MONTHS":
            ruleValue = "Redeem Once Every Year";
            break;
          case "CONTINUALLY":
            ruleValue = "Redeem Continually";
            break;
          default:
            ruleValue = "";
        }
      } else if (necessaryRule === "REDEEM_ONCE") {
        switch (data.redemptionFrequency) {
          case "DAILY":
            ruleValue = "Daily";
            break;
          case "ONCE":
            ruleValue = "Daily";
            break;
          case "IN_A_WEEK":
            ruleValue = "In a Week";
            break;
          case "EVERY_30_DAYS":
            ruleValue = "Every 30 Days";
            break;
          case "EVERY_90_DAYS":
            ruleValue = "Every 90 Days";
            break;
          case "EVERY_120_DAYS":
            ruleValue = "Every 120 Days";
            break;
          case "ONCE_IN_12_MONTHS":
            ruleValue = "Once in 12 Months";
            break;
          default:
            ruleValue = "";
        }
      } else if (necessaryRule === "CHOOSE_DATE_RANGE") {
        setFieldValue("ruleSelection", "CHOOSE_DATE_RANGE");
        ruleValue = "";
      }
      setFieldValue("rules", ruleValue);
    }

    setFieldValue(
      "startDate",
      data?.startDate !== null ? dayjs(data?.startDate) : ""
    );
    setFieldValue(
      "endDate",
      data?.endDate !== null ? dayjs(data?.endDate) : ""
    );

    if (data?.startTime && data?.endTime) {
      // Check if times are default values
      const isDefaultTime =
        data?.startTime === "12:01 AM" && data?.endTime === "11:59 PM";

      setUseDefaultTime(!isDefaultTime);

      // Only set time values if not using default times
      if (!isDefaultTime) {
        setFieldValue("startTime", dayjs(data?.startTime, format));
        setFieldValue("endTime", dayjs(data?.endTime, format));
      }
    }

    const tradingDays = data?.redemptionDays?.map(
      (day) => day?.charAt(0)?.toUpperCase() + day?.slice(1)?.toLowerCase()
    );
    setFieldValue("days", tradingDays || []);
  };


  const initialValues = {
    redemedOffer: "Alphanumeric Code",
    url: "",
    ruleSelection: "Redeem Once",
    rules: "",
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
    days: [],
  };

  const customizeOfferValidation = (values) => {
    const errors = {};

    if (!values.rules && values.ruleSelection !== "CHOOSE_DATE_RANGE") {
      errors.rules = "Required";
    }
    // Determine when date fields are required (mirrors UI rendering logic)
    const datesRequired =
      values.rules !== "Redeem Continually" &&
      !(
        values.ruleSelection === "OFFER_AVAILABLE_THROUGHOUT_YEAR" &&
        values.rules === "Redeem Once Daily"
      ) &&
      !(
        values.ruleSelection === "REDEEM_ONCE" &&
        values.rules === "Once in 12 Months"
      );

    if (datesRequired) {
      if (!values.startDate) {
        errors.startDate = "Start date is required";
      }
      if (!values.endDate) {
        errors.endDate = "End date is required";
      }
      if (values.startDate && values.endDate) {
        const start = dayjs(values.startDate);
        const end = dayjs(values.endDate);
        if (end.isBefore(start)) {
          errors.endDate = "End date must be after start date";
        }
      }
    }

    if (values.url && isSubmitted && !isValidUrl(values.url)) {
      errors.url = "Invalid URL format";
    }

    // Time validations when specific hours are enabled
    if (useDefaultTime) {
      if (!values.startTime) {
        errors.startTime = "Start time is required";
      }
      if (!values.endTime) {
        errors.endTime = "End time is required";
      }
      if (values.startTime && values.endTime) {
        const startT = dayjs(values.startTime);
        const endT = dayjs(values.endTime);
        if (endT.isSame(startT)) {
          errors.endTime = "End time must be different from start time";
        }
        // Allow overnight windows where end time is before start time (next day)
      }
    }

    return errors;
  };

  const formik = useFormik({
    initialValues: initialValues,
    validate: customizeOfferValidation,
    onSubmit: async (values) => {
      const createPromise = await dispatch(
        createOffer({
          ...payload,
          offerId: isEdit ? editOfferData?._id : offerData?._id,
        })
      )?.unwrap();
      if (createPromise?.success === true) {
        setIsSubmitted(true);
        setStepIndex(stepIndex + 1);
      }
    },
  });

  const {
    redemedOffer,
    url,
    ruleSelection,
    rules,
    startDate,
    endDate,
    startTime,
    endTime,
    days,
  } = formik.values;

  useEffect(() => {
    // Prioritize offerData (current draft) over editOfferData (initial state)
    // to ensure valid changes are preserved when navigating back
    const sourceData = offerData?._id ? offerData : editOfferData;

    if (sourceData) {
      fillUpForm(sourceData);
    }
    console.log("useDefaultTime", useDefaultTime);
  }, [offerData, editOfferData]);

  const handleDefaultTimeToggle = () => {
    const newVal = !useDefaultTime;
    setUseDefaultTime(newVal);
    if (!newVal) {
      // Switching to default time (unchecked) - clear custom times
      setFieldValue("startTime", null);
      setFieldValue("endTime", null);
    }
  };

  const handleContinueClick = (redemptionMethod) => {
    setModalContent(redemptionMethod);
    setFieldValue("redemedOffer", redemptionMethod);
    if (redemptionMethod === "QR Code" || redemptionMethod === "Barcode") {
      setShowVerificationModal(true);
      setShowRedemptionModal(false);
    } else {
      setShowRedemptionModal(false);
    }
  };

  const handleConfirmClick = (verification) => {
    setSelectedVerification(verification);
    setShowVerificationModal(false);
  };

  const payload = React.useMemo(
    () => ({
      necessaryRule:
        !rules && ruleSelection !== "CHOOSE_DATE_RANGE"
          ? null
          : ruleSelection === "REDEEM_ONCE"
            ? "REDEEM_ONCE"
            : ruleSelection === "OFFER_AVAILABLE_THROUGHOUT_YEAR"
              ? "OFFER_AVAILABLE_THROUGHOUT_YEAR"
              : ruleSelection === "CHOOSE_DATE_RANGE"
                ? "CHOOSE_DATE_RANGE"
                : null,
      redemptionFrequency:
        ruleSelection !== "CHOOSE_DATE_RANGE" &&
          (rules === "Redeem Once" || rules === "REDEEM_ONCE")
          ? "DAILY"
          : rules === "Daily"
            ? "DAILY"
            : (ruleSelection === "OFFER_AVAILABLE_THROUGHOUT_YEAR" &&
              rules === "Redeem Once Daily") ||
              (ruleSelection === "REDEEM_ONCE" && rules === "Daily")
              ? "ONCE"
              : rules === "In a Week" || rules === "Redeem Once Every Week"
                ? "IN_A_WEEK"
                : rules === "Every 30 Days" || rules === "Redeem Once Every Month"
                  ? "EVERY_30_DAYS"
                  : rules === "Every 90 Days"
                    ? "EVERY_90_DAYS"
                    : rules === "Every 120 Days"
                      ? "EVERY_120_DAYS"
                      : rules === "Once in 12 Months" || rules === "Redeem Once Every Year"
                        ? "ONCE_IN_12_MONTHS"
                        : rules === "Redeem Continually"
                          ? "CONTINUALLY"
                          : "",
      ...((rules !== "Redeem Continually") && {
        startDate: startDate,
        endDate: endDate,
        startTime: startTime ? startTime.format(format) : null,
        endTime: endTime ? endTime.format(format) : null,
        redemptionDays: rules === "Daily" ? null : days?.map((day) => day.toUpperCase()),
      }),
      ...(((ruleSelection === "OFFER_AVAILABLE_THROUGHOUT_YEAR" &&
        rules === "Redeem Once Daily") ||
        (ruleSelection === "REDEEM_ONCE" &&
          rules === "Once in 12 Months")) && {
        startDate: null,
        endDate: null,
        startTime: startTime ? startTime.format(format) : null,
        endTime: endTime ? endTime.format(format) : null,
        redemptionDays: null,
      }),
      id: offerData?._id,
      merchantId: selectedMerchant?._id,
      isCreated: false,
      callback_url: url || null,
      redemptionMethod:
        redemedOffer === "Alphanumeric Code"
          ? "SWOODLE_CODE_OFFER"
          : redemedOffer === "QR Code"
            ? "QR_CODE"
            : redemedOffer === "BarCode"
              ? "BAR_CODE"
              : "SWOODLE_CODE_OFFER",
    }),
    [
      rules,
      ruleSelection,
      startDate,
      endDate,
      startTime,
      endTime,
      days,
      offerData?._id,
      url,
      redemedOffer,
      format,
    ]
  );

  useEffect(() => {
    console.log("Payload Data on Customize Offer Step:", payload);
    console.log("ERRORS:", formik.errors);
    console.log("Touched:", formik.touched);
    setPayloadData(payload);
  }, [
    redemedOffer,
    url,
    ruleSelection,
    rules,
    startDate,
    endDate,
    days,
    startTime,
    endTime,
    offerData?._id,
    useDefaultTime,
  ]);

  const {
    handleChange,
    handleBlur,
    errors,
    touched,
    setFieldValue,
    handleSubmit,
    setValues,
    setFieldTouched,
  } = formik;

  const attemptNext = async () => {
    const validationErrors = await formik.validateForm();
    if (Object.keys(validationErrors || {}).length > 0) {
      // Mark all errored fields as touched so inline messages render
      Object.keys(validationErrors || {}).forEach((field) =>
        setFieldTouched(field, true, false)
      );
      const keys = Object.keys(validationErrors || {});
      if (keys.length) {
        const el = window.document.querySelector(`[name="${keys[0]}"]`);
        if (el && typeof el.scrollIntoView === "function") {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      }
      return;
    }
    handleSubmit();
  };

  const radioOptions =
    ruleSelection === "OFFER_AVAILABLE_THROUGHOUT_YEAR"
      ? [
        "Redeem Once Daily",
        "Redeem Once Every Week",
        "Redeem Once Every Month",
        "Redeem Once Every Year",
        "Redeem Continually",
      ]
      : [
        "Daily",
        "In a Week",
        "Every 30 Days",
        "Every 90 Days",
        "Every 120 Days",
        "Once in 12 Months",
      ];

  const handleDayClick = (day) => {
    const currentDays = formik.values.days || [];
    const isSelected = currentDays.find((d) => d === day);

    if (isSelected) {
      const updatedDays = currentDays.filter((d) => d !== day);
      setFieldValue("days", updatedDays);
    } else {
      const d = weekDays.find((d) => d === day);
      setFieldValue("days", [...currentDays, d]);
    }
  };

  const isDayClicked = (day) => {
    return days?.find((sDay) => sDay.toUpperCase() === day.toUpperCase());
  };

  const handleRedemedOfferChange = (e) => {
    setFieldValue("redemedOffer", e);
    setShowUploadDocument(false);
    // Check if QR Code or Barcode is selected and show the modal
    if (e === "QR Code" || e === "Barcode") {
      setModalContent(e); // Store which content to show (QR Code or Barcode)
      setTimeout(() => {
        setShowRedemptionModal(true); // Show the modal after 1 second
      }, 500);
    } else {
      setShowRedemptionModal(false); // Hide modal if other options are selected
    }
  };

  const handleSwoodleCodeChange = (code) => {
    setFieldValue("redemedOffer", code);
  };

  const rulesOptions = [
    { label: "Redeem Once", value: "REDEEM_ONCE" },
    {
      label: "Offer Available throughout the Year",
      value: "OFFER_AVAILABLE_THROUGHOUT_YEAR",
    },
    { label: "Choose a Date Range", value: "CHOOSE_DATE_RANGE" },
  ];

  const handleRuleSelectionChange = (e) => {
    console.log(e, "e1234567890");
    setFieldValue("ruleSelection", e);
    setFieldValue("rules", "");
  };

  useEffect(() => {
    if (payload.necessaryRule === "CHOOSE_DATE_RANGE") {
      setFieldValue("redemptionFrequency", null);
      payload.redemptionFrequency = null; // Update the payload as well
    } else if (
      payload.necessaryRule === "OFFER_AVAILABLE_THROUGHOUT_YEAR" &&
      payload.redemptionFrequency === "ONCE"
    ) {
      setFieldValue("startDate", null);
      setFieldValue("endDate", null);
      setFieldValue("redemptionDays", null);
      payload.startDate = null; // Update the payload as well
      payload.endDate = null; // Update the payload as well
      payload.redemptionDays = null; // Update the payload as well
    } else if (
      payload.necessaryRule === "REDEEM_ONCE" &&
      payload.redemptionFrequency === "ONCE_IN_12_MONTHS"
    ) {
      setFieldValue("startDate", null);
      setFieldValue("endDate", null);
      setFieldValue("redemptionDays", null);
      payload.startDate = null; // Update the payload as well
      payload.endDate = null; // Update the payload as well
      payload.redemptionDays = null; // Update the payload as well
    }
  }, [payload, setFieldValue]); // Re-run this effect when ruleSelection changes

  const isNextButtonBusy = Boolean(loading);
  const shouldRequireDays =
    (ruleSelection === "OFFER_AVAILABLE_THROUGHOUT_YEAR" &&
      rules !== "Redeem Once Daily" &&
      rules !== "Redeem Continually") ||
    (ruleSelection === "REDEEM_ONCE" &&
      rules !== "Daily" &&
      rules !== "Once in 12 Months");

  const shouldRequireDates =
    rules !== "Redeem Continually" &&
    !(
      ruleSelection === "OFFER_AVAILABLE_THROUGHOUT_YEAR" &&
      rules === "Redeem Once Daily"
    ) &&
    !(ruleSelection === "REDEEM_ONCE" && rules === "Once in 12 Months");

  const isNextButtonDisabled =
    isNextButtonBusy ||
    (shouldRequireDays &&
      (!Array.isArray(days) || (Array.isArray(days) && days.length === 0))) ||
    (shouldRequireDates && (!startDate || !endDate));
  const nextButtonLabel = isNextButtonBusy ? (
    <span className="flex items-center justify-center gap-2">
      <span className="offer-btn-spinner" />
      <span>Processing...</span>
    </span>
  ) : (
    "Next"
  );

  return (
    <div className="w-full flex flex-col items-center justify-center mt-20">
      <div className="sm:w-[100%] md:w-[80%] lg:w-[70%] xl:w-[55%] offerform customize">
        <div className="w-full flex flex-col justify-start items-start gap-4 mb-4">
          <div className="flex flex-col justify-start items-start gap-2">
            <p className="font-poppins font-[500] sm:text-[12px] md:text-[14px] lg:text-[16px] text-[#303030]">
              Let's customise your{" "}
              <span className="text-[#00A5E2]">{offerData?.offerType !== "ONLINE_OFFER" ? "In Store Swoodle" : "Online"}</span> offer
            </p>
            <p className="font-poppins font-[400] sm:text-[12px] md:text-[14px] text-[#767676]">
              Review the options that you can offer to your customers.
            </p>
          </div>
          {offerData?.offerType !== "ONLINE_OFFER" && (
            <div className="flex flex-col justify-start items-start gap-2">
              <p className="font-poppins font-[600] sm:text-[12px] md:text-[14px] lg:text-[16px] text-[#303030]">
                Your Redemption Method
              </p>
              <p className="font-poppins font-[400] sm:text-[12px] md:text-[14px] text-[#767676]">
                This determines how customers will redeem your offer. Based on
                your selection, they will be shown one of the following to share
                with the merchant.
              </p>
            </div>
          )}
        </div>
        {offerData?.offerType !== "ONLINE_OFFER" && (
          <>
            <SelectOption
              clicked={redemedOffer === "Alphanumeric Code"}
              icon={alphanumericIcon}
              title={"Swoodle Code Offer"}
              handleClick={() => {
                handleSwoodleCodeChange("Alphanumeric Code");
              }}
              postIcon={null}
              greyIcon={false}
              exampleText="eg. SWD8XK9"
            />
            <div className="flex flex-col justify-start items-start gap-2 mt-4 border-b border-b-[#D9D9D9] pb-6">
              <SelectOption
                clicked={redemedOffer === "QR Code"}
                icon={qrIcon}
                title={"QR Code Offer"}
                handleClick={() => handleSwoodleCodeChange("QR Code")}
                postIcon={null}
                greyIcon={false}
                useCustomGrey={true}
              />
              <SelectOption
                clicked={redemedOffer === "BarCode"}
                icon={barcodeIcon}
                title={"Bar Code Offer"}
                handleClick={() => handleSwoodleCodeChange("BarCode")}
                postIcon={null}
                greyIcon={false}
                useCustomGrey={true}
              />

              <Input
                type="text"
                label={
                  <div className="flex items-center gap-2">
                    Callback URL Option (Optional)
                    <Tooltip
                      title="Provide a callback URL to track offer redemptions in your existing system."
                      color="#8C8C8C"
                      placement="top"
                    >
                      <InfoIcon1 className="w-[14px] h-[14px] cursor-pointer hover:opacity-80 transition-opacity info-icon-grey" />
                    </Tooltip>
                  </div>
                }
                labelClassName="lg:!text-[14px] sm:!text-[12px] !font-[600] !text-[#303030] !font-poppins flex items-center"
                placeholder="Click to add your callback url"
                width="100%"
                radius="5px"
                InputDivClass="w-[100%]"
                name="url"
                value={url}
                handleChange={handleChange}
                handleBlur={handleBlur}
                error={errors.url}
                touched={touched.url}
              />
            </div>
          </>
        )}
        <Selector
          // defaultValue={"REDEEM_ONCE"}
          value={ruleSelection}
          label={"Necessary Rules:"}
          labelClassName="md:!text-[14px] sm:!text-[12px] !font-[600] !text-[#303030] font-poppins leading-[21px] mb-4"
          divClassName="mt-5 w-[100%]"
          selectClassName="w-full rounded-[5px] bg-[#FFFFFF] text-[#303030] lg:text-[16px] sm:text-[10px] font-[400] !font-poppins !focus:outline-none"
          flexClassName="gap-3"
          options={rulesOptions}
          suffixIcon={<DownArrow />}
          placeholder={"Select Rules"}
          onChange={handleRuleSelectionChange}
          handleBlur={handleBlur}
          error={errors.ruleSelection}
          touched={touched.ruleSelection}
        />
        {(ruleSelection === "OFFER_AVAILABLE_THROUGHOUT_YEAR" ||
          ruleSelection === "REDEEM_ONCE") && (
            <RadioSelection
              options={radioOptions}
              divClassName="mt-8"
              internalDivClass="flex flex-col items-start"
              secondRadioClass="mt-3"
              textClass="sm:text-[10px] md:text-[12px] lg:text-[14px] font-[400] text-[#303030] ml-4"
              label={""}
              width={"100%"}
              name="rules"
              value={rules}
              error={errors.rules}
              touched={touched.rules}
              setFieldValue={setFieldValue}
            />
          )}
        {/* <p className="font-poppins font-[400] sm:text-[10px] md:text-[12px] lg:text-[14px] text-[#303030] mt-5">
          What time is this offer available to be claimed and at what days?
        </p> */}
        {rules &&
          rules !== "Redeem Continually" &&
          ruleSelection === "OFFER_AVAILABLE_THROUGHOUT_YEAR" && (
            <div className="flex flex-col justify-start items-start gap-2 mt-5 border border-[#D9D9D9] bg-[#FCFCFC] p-4 rounded-[5px]">
              {rules !== "Redeem Once Daily" && rules !== "Daily" && (
                <div className="w-full">
                  <div className="flex sm:flex-col md:flex-row justify-between w-[100%]">
                    <div className="md:w-[46%] sm:w-[100%]">
                      <p className="invitationLabels !font-[600]">Start Date</p>
                      <DatePicker
                        className="invitationInputs w-[100%]"
                        style={{ width: "100%", fontSize: "16px" }}
                        format="YYYY-MM-DD"
                        placeholder="Select Start Date"
                        name="startDate"
                        defaultValue={startDate}
                        value={startDate}
                        onChange={(date, dateString) => {
                          setFieldValue("startDate", date);
                        }}
                        onBlur={handleBlur}
                        suffixIcon={
                          <CalendarOutlined style={{ cursor: "pointer" }} />
                        }
                      />
                      <div className="ms-1">
                        <span className="text-red-600 text-[11px] font-[600] text-start">
                          {errors.startDate && touched.startDate
                            ? errors.startDate
                            : null}
                        </span>
                      </div>
                    </div>
                    <div className="md:w-[46%] sm:w-[100%] sm:mt-5 md:mt-0">
                      <p className="invitationLabels !font-[600]">End Date</p>
                      <DatePicker
                        className="invitationInputs w-[100%]"
                        style={{ width: "100%", fontSize: "16px" }}
                        format="YYYY-MM-DD"
                        placeholder="Select End Date"
                        name="endDate"
                        defaultValue={endDate}
                        value={endDate}
                        onChange={(date, dateString) => {
                          setFieldValue("endDate", date);
                        }}
                        onBlur={handleBlur}
                      />
                      <span className="text-red-600 text-[11px] font-[600] ms-1">
                        {errors.endDate && touched.endDate
                          ? errors.endDate
                          : null}
                      </span>
                    </div>
                  </div>
                  <p className="font-poppins font-[600] sm:text-[10px] md:text-[12px] lg:text-[14px] text-[#303030] mt-4">
                    Choose days of the week
                  </p>
                  <DayBox
                    days={weekDays}
                    handleDayClick={handleDayClick}
                    isDayClicked={isDayClicked}
                  />
                  <span className="text-red-600 text-[12px] font-[600] ms-1">
                    {errors.days && touched.days ? errors.days : null}
                  </span>
                </div>
              )}
              <div className="w-[60%] flex items-center customize">
                <Checkbox
                  text="Check to set specific hours; leave unchecked for all-time availability."
                  divClassName="flex items-center justify-center"
                  checked={useDefaultTime}
                  onChecked={handleDefaultTimeToggle}
                  textClass="lg:text-[14px] sm:text-[12px] font-[500] font-poppins text-[#303030] ml-2 lg:whitespace-nowrap sm:whitespace-normal"
                  UncheckedIcon={UncheckedIcon}
                />
              </div>
              {useDefaultTime && (
                <div className="flex sm:flex-col md:flex-row justify-between mt-5 w-[100%]">
                  <div className="md:w-[46%] sm:w-[100%]">
                    <p className="invitationLabels !font-[600]">Start Time</p>
                    <TimePicker
                      className="invitationInputs w-[100%]"
                      style={{ width: "100%", fontSize: "16px" }}
                      placeholder="Select Start Time"
                      format={format}
                      name="startTime"
                      defaultValue={startTime}
                      use12Hours={true}
                      value={startTime}
                      onChange={(date, dateString) => {
                        setFieldValue("startTime", date);
                      }}
                      onBlur={() => setFieldTouched("startTime", true, true)}
                    />
                    <span className="text-red-600 text-[12px] font-[600] ms-1">
                      {errors.startTime && touched.startTime
                        ? errors.startTime
                        : null}
                    </span>
                  </div>
                  <div className="md:w-[46%] sm:w-[100%] sm:mt-5 md:mt-0">
                    <p className="invitationLabels !font-[600]">End Time</p>
                    <TimePicker
                      className="invitationInputs w-[100%]"
                      style={{ width: "100%", fontSize: "16px" }}
                      placeholder="Select End Time"
                      format={format}
                      name="endTime"
                      defaultValue={endTime}
                      use12Hours={true}
                      value={endTime}
                      onChange={(date, dateString) => {
                        setFieldValue("endTime", date);
                      }}
                      onBlur={() => setFieldTouched("endTime", true, true)}
                    />
                    <span className="text-red-600 text-[12px] font-[600] ms-1">
                      {errors.endTime && touched.endTime
                        ? errors.endTime
                        : null}
                    </span>
                  </div>
                </div>
              )}
            </div>
          )}
        {((ruleSelection === "REDEEM_ONCE" && rules) ||
          ruleSelection === "CHOOSE_DATE_RANGE") && (
            <div className="flex flex-col justify-start items-start gap-2 mt-5 border border-[#D9D9D9] bg-[#FCFCFC] p-4 rounded-[5px]">
              {rules !== "Once in 12 Months" && (
                <div className="flex sm:flex-col md:flex-row justify-between w-[100%]">
                  <div className="md:w-[46%] sm:w-[100%]">
                    <p className="invitationLabels !font-[600]">Start Date</p>
                    <DatePicker
                      className="invitationInputs w-[100%]"
                      style={{ width: "100%", fontSize: "16px" }}
                      format="YYYY-MM-DD"
                      placeholder="Select Start Date"
                      name="startDate"
                      defaultValue={startDate}
                      value={startDate}
                      onChange={(date, dateString) => {
                        setFieldValue("startDate", date);
                      }}
                      onBlur={handleBlur}
                      suffixIcon={
                        <CalendarOutlined style={{ cursor: "pointer" }} />
                      }
                    />
                    <div className="ms-1">
                      <span className="text-red-600 text-[11px] font-[600] text-start">
                        {errors.startDate && touched.startDate
                          ? errors.startDate
                          : null}
                      </span>
                    </div>
                  </div>
                  <div className="md:w-[46%] sm:w-[100%] sm:mt-5 md:mt-0">
                    <p className="invitationLabels !font-[600]">End Date</p>
                    <DatePicker
                      className="invitationInputs w-[100%]"
                      style={{ width: "100%", fontSize: "16px" }}
                      format="YYYY-MM-DD"
                      placeholder="Select End Date"
                      name="endDate"
                      defaultValue={endDate}
                      value={endDate}
                      onChange={(date, dateString) => {
                        setFieldValue("endDate", date);
                      }}
                      onBlur={handleBlur}
                    />
                    <span className="text-red-600 text-[11px] font-[600] ms-1">
                      {errors.endDate && touched.endDate ? errors.endDate : null}
                    </span>
                  </div>
                </div>
              )}
              {rules !== "Daily" && rules !== "Once in 12 Months" && (
                <div className="w-full">
                  <p className="font-poppins font-[600] sm:text-[10px] md:text-[12px] lg:text-[14px] text-[#303030] mt-4">
                    Choose days of the week
                  </p>
                  <DayBox
                    days={weekDays}
                    handleDayClick={handleDayClick}
                    isDayClicked={isDayClicked}
                  />
                  <span className="text-red-600 text-[12px] font-[600] ms-1">
                    {errors.days && touched.days ? errors.days : null}
                  </span>
                </div>
              )}
              <div className="w-[60%] flex items-center customize">
                <Checkbox
                  text="Check to set specific hours, leave unchecked for all time availability"
                  divClassName="flex items-center justify-center"
                  checked={useDefaultTime}
                  onChecked={handleDefaultTimeToggle}
                  textClass="lg:text-[14px] sm:text-[12px] font-[500] font-poppins text-[#303030] ml-2 lg:whitespace-nowrap sm:whitespace-normal"
                  UncheckedIcon={UncheckedIcon}
                />
              </div>
              {useDefaultTime && (
                <div className="flex sm:flex-col md:flex-row justify-between mt-5 w-[100%]">
                  <div className="md:w-[46%] sm:w-[100%]">
                    <p className="invitationLabels !font-[600]">Start Time</p>
                    <TimePicker
                      className="invitationInputs w-[100%]"
                      style={{ width: "100%", fontSize: "16px" }}
                      placeholder="Select Start Time"
                      format={format}
                      name="startTime"
                      defaultValue={startTime}
                      use12Hours={true}
                      value={startTime}
                      onChange={(date, dateString) => {
                        setFieldValue("startTime", date);
                      }}
                      onBlur={() => setFieldTouched("startTime", true, true)}
                    />
                    <span className="text-red-600 text-[12px] font-[600] ms-1">
                      {errors.startTime && touched.startTime
                        ? errors.startTime
                        : null}
                    </span>
                  </div>
                  <div className="md:w-[46%] sm:w-[100%] sm:mt-5 md:mt-0">
                    <p className="invitationLabels !font-[600]">End Time</p>
                    <TimePicker
                      className="invitationInputs w-[100%]"
                      style={{ width: "100%", fontSize: "16px" }}
                      placeholder="Select End Time"
                      format={format}
                      name="endTime"
                      defaultValue={endTime}
                      use12Hours={true}
                      value={endTime}
                      onChange={(date, dateString) => {
                        setFieldValue("endTime", date);
                      }}
                      onBlur={() => setFieldTouched("endTime", true, true)}
                    />
                    <span className="text-red-600 text-[12px] font-[600] ms-1">
                      {errors.endTime && touched.endTime ? errors.endTime : null}
                    </span>
                  </div>
                </div>
              )}
            </div>
          )}
        <div className="w-full text-end mt-20">
          <GreyButton
            className="w-[40%] lg:w-[25%] h-[45px] rounded-[5px] text-[16px] font-[500] font-montserrat"
            label="Previous"
            onClick={handlePrevious}
          />
          <PrimaryButton
            className={
              "w-[40%] lg:w-[25%] h-[45px] rounded-[5px] text-[16px] font-[500] font-montserrat ms-2"
            }
            label={nextButtonLabel}
            disabled={isNextButtonDisabled}
            onClick={attemptNext}
          />
        </div>
      </div>
    </div>
  );
};

export default CustomizeOffer;